import { Box, Card, CardActionArea, ImageListItem } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useInViewRef } from "rooks";

import { OverrideIcon } from "assets/icons";
import { ImageQueryView } from "components/detector/ImageQueryView";
import { Typography } from "new-components/typography/Typography";
import { ImageQuery } from "types/imageQueries";
import { DATETIME_FORMAT } from "utils/date";
import { unclearOptionsArr } from "utils/ReviewPageUtils";
import { capitalize } from "utils/shared";

const unclearOptionsArray = [
  ...unclearOptionsArr,
  {
    name: "Image contains inappropriate content",
    value: "image contains inappropriate content",
  },
];

interface FlaggedListItemProps {
  posicheck: ImageQuery;
  relabeled?: boolean;
  handleOpenDataDetails: () => void;
}

export function FlaggedListItem(props: FlaggedListItemProps) {
  const { posicheck, relabeled, handleOpenDataDetails } = props;

  const [isVisibleOnce, setIsVisibleOnce] = useState(false);
  const [myRef, inView] = useInViewRef();

  useEffect(() => {
    if (inView && !isVisibleOnce) {
      setIsVisibleOnce(true);
    }
  }, [inView, isVisibleOnce]);

  const feedbackTextFormated = useMemo(() => {
    const feedbackText = posicheck?.latest_flagged_label_feedback_text || "";

    if (!feedbackText)
      return {
        optionsText: "",
        feedbackText: "",
      };

    const unclearValues = unclearOptionsArray.map((option) => option.value.toLowerCase());
    const feedbackParts = feedbackText
      .toLowerCase()
      .split(";")
      .map((part) => part.trim());

    const optionsTextParts: string[] = [];
    const feedbackTextParts: string[] = [];

    feedbackParts.forEach((part) => {
      if (unclearValues.includes(part)) {
        optionsTextParts.push(part);
      } else {
        feedbackTextParts.push(part);
      }
    });

    return {
      optionsText: optionsTextParts.join(", "),
      feedbackText: feedbackTextParts.join(", "),
    };
  }, [posicheck]);

  // Format created_at date into desired display string
  const parseDate = (createdAt: string) => dayjs(createdAt).format(DATETIME_FORMAT);

  return (
    <Box className={`flex flex-row relative space-x-3 h-full w-full ${relabeled ? "opacity-50" : ""}`} ref={myRef}>
      <ImageListItem className="text-sm w-[25%] cursor-pointer" onClick={handleOpenDataDetails}>
        <ImageQueryView imageQuery={posicheck} />
      </ImageListItem>
      <Box className="flex flex-col justify-between w-[70%]">
        <Typography variant="subtitle" fontWeight="bold" className="text-primary-darker mb-4">
          {feedbackTextFormated.optionsText
            ? capitalize(feedbackTextFormated.optionsText)
            : "No feedback options selected."}
        </Typography>
        <Typography variant="subtitle" fontWeight="bold" className="text-black mb-4">
          {feedbackTextFormated.feedbackText
            ? capitalize(feedbackTextFormated.feedbackText)
            : "No feedback text entered."}
        </Typography>
        <Typography variant="small" fontWeight="bold" className="text-black mb-2">
          {`Created at ${parseDate(posicheck?.created_at)}`}
        </Typography>
        <Box className="flex fYelex-row justify-between gap-2">
          <Card className="rounded-md w-1/2 self-center bg-neutral-300">
            <CardActionArea
              onClick={handleOpenDataDetails}
              disabled={relabeled}
              className="h-full flex justify-between px-2"
            >
              <Typography align="center" className="text-black">
                Override Label
              </Typography>
              <OverrideIcon color="#000" />
            </CardActionArea>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
